export enum LicenseTier {
  FREE = "free",
  STARTER = "starter",
  PRO = "pro",
  PREMIUM = "premium",
  HOMETRACK = "hometrack",
}

const PLAN_TO_TIER: Record<string, { name: LicenseTier; code: number }> = {
  hometrack: { name: LicenseTier.HOMETRACK, code: 5 },
  unlimited: { name: LicenseTier.PREMIUM, code: 4 },
  pro: { name: LicenseTier.PRO, code: 3 },
  starter: { name: LicenseTier.STARTER, code: 2 },
  free: { name: LicenseTier.FREE, code: 1 },
};

export const getLicenseTier = ({ plan }: { plan: string }): { name: LicenseTier; code: number } =>
  PLAN_TO_TIER[plan] || { name: LicenseTier.FREE, code: 1 };

export const getLicenseCode = ({ license }: { license: LicenseTier }): number => {
  const entry = Object.values(PLAN_TO_TIER).find((tier) => tier.name === license);
  return entry ? entry.code : 1;
};
